import VErrorBackToRefUrl from '@/components/Error/ErrorBackToRefUrl';

export default (context, data) => {
  data.retryButtonHook = VErrorBackToRefUrl;
  data.retryButtonBindings.refUrl = context.$route.query.refurl || context.$store.state.system.refUrl;
  data.retryButtonBindings.redirectTime = context.$store.state.system.errorRedirectionTime;

  return {};
};
